import React from 'react';
import root from 'window-or-global';
import {Button, Message, Icon, svgs, buttonTypes, priority} from 'epic-diesel-common';

//@ts-ignore
import styles from './LoadMore.pcss';

interface Props {
    forwardedRef?: any;
    isLoading: boolean;
    hasError: boolean;
    hasReachedEndOfData: boolean;
    loadMoreCallback: VoidFunction;
}

const CODES = {
    end: 'epic.affiliate.news.end',
    error: {
        header: 'epic.affiliate.social.channels.errors.somethingWrong.v2',
        cta: 'epic.affiliate.news.loadMore'
    }
};

class LoadMore extends React.PureComponent<Props> {
    static defaultProps = {
        loadMoreCallback: () => {}
    };

    componentDidMount() {
        root.window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        root.window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        const {forwardedRef, isLoading, hasError, hasReachedEndOfData} = this.props;

        if (!forwardedRef || !forwardedRef.current) {
            return;
        }

        // Whether enough time has passed that we're allowed to load more data
        const elementRect:
            | DOMRect
            | ClientRect
            | undefined = forwardedRef.current.getBoundingClientRect();

        if (!elementRect) {
            return;
        }

        // const isScrollAtTop: boolean = elementRect.top >= 0 && elementRect.top <= root.window.innerHeight;
        const isScrollAtBottom: boolean = elementRect.bottom <= root.window.innerHeight + 400; // Additional space so it loads more eagerly

        if (forwardedRef && !hasError) {
            // User scrolled down: can reload at the bottom
            if (!isLoading && isScrollAtBottom && !hasReachedEndOfData) {
                // Show error message at bottom on infinite scrolling failure
                this.props.loadMoreCallback();
            }
        }
    };

    render() {
        const {loadMoreCallback, isLoading, hasReachedEndOfData, hasError} = this.props;

        let renderJSX = null;

        if (isLoading) {
            renderJSX = (
                <div className={styles.loader}>
                    <Icon className={styles.icon} icon={svgs.LOADING} fontSize="large" />
                </div>
            );
        } else if (hasError) {
            renderJSX = (
                <>
                    <Message code={CODES.error.header} />
                    <Button
                        theme="dark"
                        type={buttonTypes.BUTTON}
                        priority={priority.PRIMARY}
                        onClick={loadMoreCallback}>
                        <Message code={CODES.error.cta} />
                    </Button>
                </>
            );
        } else if (hasReachedEndOfData) {
            renderJSX = <Message code={CODES.end} />;
        }

        return renderJSX ? <div className={styles.loadMore}>{renderJSX}</div> : null;
    }
}

export default React.forwardRef((props: Props, ref) => {
    return <LoadMore {...props} forwardedRef={ref} />;
});
